import { NgZone } from '@angular/core';
import { MatLegacySnackBar } from '@angular/material/legacy-snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslocoService } from '@ngneat/transloco';

export class SnackbarHelper {
  static showTranslatableSnackBar(
    ngZone: NgZone,
    snackBar: MatLegacySnackBar,
    translocoService: TranslocoService,
    key: string,
    duration: number = 3000,
    vPos: 'top' | 'bottom' = 'bottom',
    panelClass: string = '',
  ) {
    ngZone.run(() => {
      snackBar.open(translocoService ? translocoService.translate(key) : key, '', {
        panelClass,
        duration: duration,
        horizontalPosition: 'center',
        verticalPosition: vPos,
      });
    });
  }

  /*
  Deprecated method. Use showSnackBarV3 instead.
  After full migration to non-legacy material, please remove showSnackBar and rename showSnackBarV3 to showSnackBar.
  */
  static showSnackBar(
    ngZone: NgZone,
    snackBar: MatLegacySnackBar,
    message: string,
    duration: number = 3000,
    vPos: 'top' | 'bottom' = 'bottom',
  ) {
    ngZone.run(() => {
      snackBar.open(message, '', { duration: duration, horizontalPosition: 'center', verticalPosition: vPos });
    });
  }

  static showSnackBarV3(
    ngZone: NgZone,
    snackBar: MatSnackBar,
    message: string,
    duration: number = 3000,
    vPos: 'top' | 'bottom' = 'bottom',
  ) {
    ngZone.run(() => {
      snackBar.open(message, '', { duration: duration, horizontalPosition: 'center', verticalPosition: vPos });
    });
  }
}
